import type { StateCreator } from 'zustand';

export interface LoadingSlice {
  clearLoading: () => void;
  loading: { id: string }[];
  removeLoading: (id: string) => void;
  setLoading: (loading: { id: string }) => void;
}

export const loadingSlice: StateCreator<LoadingSlice, [], [], LoadingSlice> = (
  set,
) => ({
  loading: [],
  setLoading: (loading: { id: string }) =>
    set((state) => ({
      loading: [...state.loading, loading],
    })),
  removeLoading: (id: string) =>
    set((state) => ({
      loading: state.loading.filter((loading) => loading.id !== id),
    })),
  clearLoading: () => set({ loading: [] }),
});
